export const isChatMessageDeleted = (msg) => {
  if (!msg || typeof msg !== "object") return false;
  if (msg.isDeleted || msg.deleted || msg.is_deleted) {
    return true;
  }
  if (msg.deletedAt || msg.deleted_at || msg.deletedBy || msg.deleted_by) {
    return true;
  }
  const status = String(msg.status || msg.messageStatus || "").toLowerCase();
  if (status === "deleted") return true;
  const type = String(msg.type || "").toLowerCase();
  return type === "deleted";
};

export const isChatMessageArchived = (msg) => {
  if (!msg || typeof msg !== "object") return false;
  const type = String(msg.type || "").toLowerCase();
  return type === "archive" || type === "archived";
};

/** Backend system notices (archive, campaign removal, etc.). */
export const isSystemGeneratedMessage = (msg) => {
  if (!msg || typeof msg !== "object") return false;
  if (isChatMessageArchived(msg)) return true;
  const type = String(msg.type || "").toLowerCase();
  return type === "system";
};

export const getSystemMessageText = (msg) => {
  if (!msg || typeof msg !== "object") return "";
  return typeof msg.message === "string" ? msg.message.trim() : "";
};

/** Deleted or archive status notices — rendered in the italic status bubble. */
export const isStatusStyleMessage = (msg) =>
  isChatMessageDeleted(msg) || isChatMessageArchived(msg);

export const withDeletedFlag = (msg) => {
  if (!msg || typeof msg !== "object") return msg;
  return { ...msg, isDeleted: isChatMessageDeleted(msg) };
};

export const getDeletedMessageLabel = ({ isOwn = false, senderName = "" } = {}) => {
  if (isOwn) return "You deleted this message";
  if (senderName) return `${senderName} deleted this message`;
  return "This message was deleted";
};

export const getMessageSenderId = (msg) => {
  if (!msg || typeof msg !== "object") return null;
  return msg.senderId?._id || msg.senderId?.id || msg.senderId || null;
};

/** Show archive text exactly as returned by the backend. */
export const getArchiveMessageLabel = (msg) => {
  if (!msg || typeof msg !== "object") return "";
  const text = typeof msg.message === "string" ? msg.message.trim() : "";
  return text || "This chat was archived";
};

export const getStatusMessageLabel = (
  msg,
  { isOwn = false, senderName = "" } = {}
) => {
  if (isChatMessageDeleted(msg)) {
    return getDeletedMessageLabel({ isOwn, senderName });
  }
  if (isChatMessageArchived(msg)) {
    return getArchiveMessageLabel(msg);
  }
  return "";
};

export const getMessagePreviewText = (msg) => {
  if (!msg) return "";
  if (typeof msg === "string") return msg;
  if (isChatMessageDeleted(msg)) return "This message was deleted";
  if (isChatMessageArchived(msg)) {
    return getArchiveMessageLabel(msg);
  }
  const type = String(msg.type || "").toLowerCase();
  if (type === "document" || type === "media") return "📎 Document";
  return msg.message || "";
};
